import { Drawer as AntdDrawer, DrawerProps } from 'antd'
import { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export const Drawer = (props: DrawerProps & Props) => <AntdDrawer {...props} />
